import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Plus, Inbox, Users, Settings, Radio, CalendarDays, ListChecks, UsersRound, MessageCircle, Table2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export function Sidebar() {
  const { user } = useAuth();
  const isAdmin = user?.perfil === 'admin';
  const isComunicacao = user?.perfil === 'comunicacao' || isAdmin;
  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="logo-dot" />
        <span>Comunica PMI</span>
      </div>

      <NavLink to="/" end>
        <LayoutDashboard size={18} /> Dashboard
      </NavLink>
      <NavLink to="/nova-demanda">
        <Plus size={18} /> Nova Demanda
      </NavLink>
      <NavLink to="/demandas">
        <Table2 size={18} /> Demandas
      </NavLink>
      <NavLink to="/minhas">
        <Inbox size={18} /> Minhas demandas
      </NavLink>
      <NavLink to="/calendario">
        <CalendarDays size={18} /> Calendário
      </NavLink>
      {isComunicacao && (
        <>
          <NavLink to="/fila">
            <ListChecks size={18} /> Minha fila
          </NavLink>
          <NavLink to="/equipe">
            <UsersRound size={18} /> Equipe
          </NavLink>
        </>
      )}
      {isAdmin && (
        <>
          <NavLink to="/admin/usuarios">
            <Users size={18} /> Usuários
          </NavLink>
          <NavLink to="/admin/secretarias">
            <Settings size={18} /> Secretarias
          </NavLink>
          <NavLink to="/admin/whatsapp">
            <MessageCircle size={18} /> WhatsApp
          </NavLink>
        </>
      )}

      <div className="sidebar-footer">
        Prefeitura de Itapecerica-MG<br />
        Secretaria de Comunicação
      </div>
    </aside>
  );
}
